import React from "react";
import { Link } from "gatsby";

const Paginator = ({ pageContext }) => {
  const { slug, numPages, currentPage } = pageContext;
  const isFirst = currentPage === 1;
  const isLast = currentPage === numPages;
  const prevPage =
    currentPage - 1 === 1 ? slug : `${slug}${(currentPage - 1).toString()}`;
  const nextPage = `${slug}${(currentPage + 1).toString()}`;
  return (
    <div>
      <ul
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          listStyle: "none",
          padding: 0,
        }}
      >
        {!isFirst && (
          <Link
            to={prevPage}
            rel="prev"
            style={{
              marginTop: "0.1rem",
              marginBottom: "0.1rem",
              padding: "0.5rem",
              color: "var(--themeColor)",
            }}
          >
            {"<< Prev"}
          </Link>
        )}
        {Array.from({ length: numPages }, (_, i) => (
          <li
            key={`pagination-number${i + 1}`}
            style={{
              margin: 0,
            }}
          >
            <Link
              to={`/${slug}${i === 0 ? "" : i + 1}`}
              style={{
                marginTop: "0.1rem",
                marginBottom: "0.1rem",
                padding: "0.5rem",
                textDecoration: "none",
                color: i + 1 === currentPage ? "#888" : "var(--themeColor)",
                background: i + 1 === currentPage ? "var(--themeColor)" : "",
              }}
            >
              {i + 1}
            </Link>
          </li>
        ))}
        {!isLast && (
          <Link
            to={nextPage}
            rel="next"
            style={{
              marginTop: "0.1rem",
              marginBottom: "0.1rem",
              padding: "0.5rem",
              color: "var(--themeColor)",
            }}
          >
            {"Next >>"}
          </Link>
        )}
      </ul>
    </div>
  );
};

export default Paginator;
